import * as Yup from "yup";
import { urlRegex, phoneRegex } from "../../utils/regex";
const validationSchema = (schema: any) => {
  const valid = Yup.object({
    name: Yup.string().required(schema.isRequired),
    nameAr: Yup.string().required(schema.isRequired),
    address: Yup.string().when('comingSoon', {
      is: false,
      then: (schemaAddress) => schemaAddress.required(schema.isRequired),
    }),
    longitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
    latitude: Yup.number()
      .typeError(schema.isNumber)
      .required(schema.isRequired),
    comingSoon: Yup.boolean(),
    openingHours: Yup.string().when('comingSoon', {
      is: false,
      then: (schemaOpeningHours) => schemaOpeningHours.required(schema.isRequired),
    }),
    openingHoursAr: Yup.string().when('comingSoon', {
      is: false,
      then: (schemaOpeningHours) => schemaOpeningHours.required(schema.isRequired),
    }),
    category: Yup.string().required(schema.isRequired),
    website: Yup.string().matches(urlRegex, schema.isURL),
    phone: Yup.string().matches(phoneRegex, schema.isPhoneNumber),
    meta: Yup.string(),
    metaAr: Yup.string(),
    parking: Yup.array().of(Yup.string()),
  });
  return valid;
};

export default validationSchema;
